import { render } from "./GetLiveLoginToken.vue?vue&type=template&id=18b9f694"
import script from "./GetLiveLoginToken.ts?vue&type=script&lang=js&external"
export * from "./GetLiveLoginToken.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__